import { TFunction } from 'react-i18next';
import { Step } from 'pages/AutomationEngine/types';
import TriggerCard from '__pages/AutomationEngine/Engine/Steps/TriggerCard';

export const content = ({ step }: { step: Step }) => step.description;

export const getDescription = ({ step, t }: { step: Step; t: TFunction }) => {
  return t('‘{{name}}’ Received', { name: step.details?.name });
};

export default function Card({ step, ...others }: { step: Step }) {
  return <TriggerCard {...others}>{content({ step })}</TriggerCard>;
}
